import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

export default {
  state: {
    categories: [],
    loading: false,
    error: false,
  },
  mutations: {
    fetch(state) {
      state.loading = true;
    },
    errorCategories(state) {
      state.categories = [];
      state.loading = false;
      state.error = true;
    },
    setCategories(state, categories) {
      state.categories = categories;
      state.loading = false;
      state.error = false;
    },
  },
  actions: {
    async fetchCategories({ commit }, { onlyActive = false } = {}) {
      commit('fetch');
      try {
        const response = await backend.getRallyCategories(onlyActive);
        await checkResponseStatus(200, response);
        const json = response.data;
        commit('setCategories', json);
      } catch (error) {
        console.error(error);
        commit('errorCategories');
      }
    },
    async createCategory(context, { category }) {
      const response = await backend.postRallyCategory(category);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async updateCategory(context, { categoryID, category }) {
      const response = await backend.putRallyCategory(categoryID, category);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async deleteCategory(context, { categoryID }) {
      const response = await backend.deleteRallyCategory(categoryID);
      await checkResponseStatus(204, response);
    },
  },
  namespaced: true,
};
